module.exports = __webpack_public_path__ + "img/lbp.805a1299.png";